import { useEffect, useRef, useState } from "react";
import { Play } from "lucide-react";

const VideoWithThumbnail = ({ src }) => {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [thumbnail, setThumbnail] = useState(null);

  useEffect(() => {
    const video = videoRef.current;

    const handleLoaded = () => {
      video.currentTime = 1;
    };

    const handleSeeked = () => {
      const canvas = canvasRef.current;
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;

      const ctx = canvas.getContext("2d");
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

      setThumbnail(canvas.toDataURL("image/png"));
    };

    video.addEventListener("loadeddata", handleLoaded);
    video.addEventListener("seeked", handleSeeked);

    return () => {
      video.removeEventListener("loadeddata", handleLoaded);
      video.removeEventListener("seeked", handleSeeked);
    };
  }, []);

  return (
    <div className="relative w-full h-full">

      {/* THUMBNAIL ONLY */}
      {thumbnail && (
        <>
          <img
            src={thumbnail}
            alt="Video Thumbnail"
            className="w-full h-full object-cover"
          />

          {/* PLAY ICON (VISUAL ONLY) */}
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="rounded-full w-16 h-16 flex items-center justify-center">
              <Play size={30} color="#c9a940" className="ml-1" />
            </div>
          </div>
        </>
      )}

      {/* HIDDEN VIDEO (ONLY FOR THUMBNAIL CAPTURE) */}
      <video
        ref={videoRef}
        src={src}
        className="hidden"
        muted
        playsInline
        crossOrigin="anonymous"
      />

      <canvas ref={canvasRef} className="hidden" />
    </div>
  );
};

export default VideoWithThumbnail;
